/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const FacilityHistoryDetails = lazyLoad(
  () => import('./index'),
  module => module.FacilityHistoryDetails,
);
